// extracted by mini-css-extract-plugin
export var card = "NewsCard-module--card--uxCH3";
export var fs = "NewsCard-module--fs--3CWmG";
export var nfs = "NewsCard-module--nfs--1Nu4B";
export var fallback = "NewsCard-module--fallback--yxp1a";
export var top = "NewsCard-module--top--2mtez";
export var date = "NewsCard-module--date--3Nhtv";
export var logo = "NewsCard-module--logo--jfUhU";